import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderComponent } from './slider.component';
export class SliderModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    SliderComponent
  ],
  exports: [
    SliderComponent
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SliderModule_tsickle_Closure_declarations() {
/** @type {?} */
SliderModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SliderModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
